/* ScheduleVeilComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");
const Renderer = require("./ScheduleVeilRenderer");
const Steve = require("@gluenetworks/steve_core").getInstance();

class ScheduleVeilComponent extends EventEmitter {
    constructor(logger, repeat, message, options) {
        super();
        this._scheduleRepeat = repeat;
        this._titleText = message || "Capture - Schedule";
        this._logger = logger;
        this._darkTheme = _.get(options, 'darkTheme', true);
        this._workType = _.get(options, "workType", null);
        this._firstTime = _.get(options, "firstTime", true);
        this._soln = _.get(options, "soln");
        this.reportFormat = "csv";
        this._userSession = Steve.di.getRegistered("$teve.userSession").registeredObj;

        this._renderer = new Renderer(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    get darkTheme() {
        return this._darkTheme;
    }

    get workType() {
        return this._workType;
    }

    get firstTime() {
        return this._firstTime;
    }

    get userSession() {
        return this._userSession;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._darkTheme = undefined;
                this._scheduleRepeat = undefined;
                this._workType = undefined;
                this._titleText = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "ScheduleVeilComponent.shutdown() error");
            }
        );
    }

    saveSchedule(scheduleDef) {
        if(this._soln === "DE") {
            scheduleDef.reportFormat = this.reportFormat;
        }
        this._context.resolve(scheduleDef);
    }

    cancelSchedule(err) {
        this._context.reject(err);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ScheduleVeilComponent;
